

import Component from './component.js';
import createComponentFactory from '../createComponent.js';
import { TweenMax, Expo } from 'gsap/umd/TweenMax';

const state = {
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded',
};

const defaultOptions = {
  state: state.EXPANDED,
  duration: 0.75
};

const overrideProps = ['display', 'overflow', 'height'];

class Accordion extends Component {

  /*
   * アコーディオンが開閉処理中かどうか
   */
  get isAnimated() {
    return this._isAnimated;
  }

  /*
   * アコーディオンの状態を取得する
   */
  get state() {
    return this._state;
  }

  constructor(element, context, options) {
    super(element, context, options);

    this.options = Object.assign({}, defaultOptions, options);

    this.control = element.querySelector(options.control || '.js-accordion__control');
    this.body = element.querySelector(options.body || '.js-accordion__expandable');


    // カスタムデータ属性から取れる設定が優先される
    this.options.state =  this.element.dataset.accordionState || this.options.state;

    // 状態遷移アニメーションが実行されているかどうか
    this._isAnimated = false;

    // 現在の状態
    this._state = this.options.state;

    // 開閉する要素にコンポーネントのスタイルを当てる前のスタイルをキャッシュする
    this._bodyStyleCache = {};

    this._toggle = null;

    this._handleControlClick = this._handleControlClick.bind(this);
  }

  _bindEvents() {
    this.control.addEventListener('click', this._handleControlClick);
  }

  _unbindEvents() {
    this.control.removeEventListener('click', this._handleControlClick);
  }

  _handleControlClick(evt) {

    evt.preventDefault();

    this._toggle();
  }

  _restoreComponent() {

    switch(this.state) {

      case state.COLLAPSED: {
        Object.assign(this.body.style, {
          height: 0,
          overflow: 'hidden',
          display: 'none'
        });

        this._toggle = this.expand;

        break;
      }

      case state.EXPANDED: {
        Object.assign(this.body.style, {
          display: '',
          overflow: 'hidden',
        });

        this._toggle = this.collapse;

        break;
      }

      default: {
        throw new Error('Illegal State');
      }
    }
  }

  _dropComponent() {
    Object.assign(this.body.style, this._bodyStyleCache);
  }

  _handleExpandComplete() {
    this.body.style.height = '';

    this._isAnimated = false;
  }

  _handleCollapseComplete() {

    Object.assign(this.body.style, {
      height: 0,
      overflow: 'hidden',
      display: 'none'
    });

    this._isAnimated = false;
  }

  expand() {

    if(this.isAnimated || state.EXPANDED === this._state) {
      return;
    }

    Object.assign(this.body.style, {
      display: 'block',
      height: '0',
      overflow: 'hidden',
      visibility: 'visible'
    });

    const actualHeight = this.body.scrollHeight;

    TweenMax.to(this.body, this.options.duration, {
      height: actualHeight,
      onComplete: this._handleExpandComplete.bind(this),
      ease: Expo.easeOut
    });

    this._state = state.EXPANDED;
    this._toggle = this.collapse;
    this._isAnimated = true;

    this.element.dataset.accordionState = this._state;
  }

  collapse() {

    if(this.isAnimated || state.COLLAPSED === this._state) {
      return;
    }

    TweenMax.to(this.body, this.options.duration, {
      height: 0,
      onComplete: this._handleCollapseComplete.bind(this),
      ease: Expo.easeOut
    });

    this._state = state.COLLAPSED;

    this._toggle = this.expand;
    this._isAnimated = true;

    this.element.dataset.accordionState = this._state;
  }

  didRegisterComponent() {

    if(!this.control || !this.body) {
      return;
    }

    for(let prop of overrideProps) {

      this._bodyStyleCache[prop] = this.body.style[prop];
    }


    this._restoreComponent();
    this._bindEvents();
  }

  didUnregisterComponent() {

    this._dropComponent();
    this._unbindEvents();

    this._bodyStyleCache = {};
  }
}


export default createComponentFactory(Accordion);



// WEBPACK FOOTER //
// ./src/js/app/component/accordion.js